import { Link } from "react-router-dom";
import { Mail, MapPin, Linkedin, Twitter, Github } from "lucide-react";
import { LOGOS } from "@/data/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative mt-24 border-t border-white/[0.06] bg-[#050F1C]">
      <div className="container-zx py-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Link to="/" className="flex items-center gap-2" data-testid="footer-logo">
            <img src={LOGOS.zolvixMark} alt="Zolvix" className="h-10 w-10 object-contain" />
            <div>
              <div className="font-display text-base font-bold text-white">ZOLVIX TECHNOLOGIES</div>
              <div className="text-[10px] font-semibold tracking-[0.24em] text-cyan">SOLVE · BUILD · SCALE</div>
            </div>
          </Link>
          <p className="mt-5 text-sm text-ink-400 max-w-xs">
            Engineering software, SaaS platforms and AI systems that drive measurable business outcomes.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="h-9 w-9 grid place-items-center rounded-md border border-white/10 text-ink-200 hover:text-white hover:border-cyan/40"><Linkedin className="h-4 w-4" /></a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter" className="h-9 w-9 grid place-items-center rounded-md border border-white/10 text-ink-200 hover:text-white hover:border-cyan/40"><Twitter className="h-4 w-4" /></a>
            <a href="https://github.com" target="_blank" rel="noreferrer" aria-label="GitHub" className="h-9 w-9 grid place-items-center rounded-md border border-white/10 text-ink-200 hover:text-white hover:border-cyan/40"><Github className="h-4 w-4" /></a>
          </div>
        </div>

        <div>
          <div className="overline mb-4">Company</div>
          <ul className="space-y-2 text-sm text-ink-200">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/case-studies" className="hover:text-white">Case Studies</Link></li>
            <li><Link to="/careers" className="hover:text-white">Careers</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Solutions</div>
          <ul className="space-y-2 text-sm text-ink-200">
            <li><Link to="/services" className="hover:text-white">Custom Software</Link></li>
            <li><Link to="/services" className="hover:text-white">SaaS Development</Link></li>
            <li><Link to="/services" className="hover:text-white">AI & Automation</Link></li>
            <li><Link to="/solutions" className="hover:text-white">ERP & CRM</Link></li>
            <li><Link to="/industries" className="hover:text-white">Industries</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm text-ink-200">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-cyan" /> Mumbai, India — Corporate & Delivery</li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-cyan" /> Dubai, UAE — Business Development</li>
            <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 text-cyan" /> <a href="mailto:info@zolvix.in" className="hover:text-white">info@zolvix.in</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="container-zx flex flex-col md:flex-row items-center justify-between gap-4 py-6">
          <div className="text-xs text-ink-400">© {year} Zolvix Technologies. All rights reserved.</div>
          <a
            href="https://www.clangrp.com"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-clan-link"
            className="group flex items-center gap-3 text-xs text-ink-400 hover:text-white"
          >
            <span>A member of the Clan Group ecosystem</span>
            <img src={LOGOS.clanMark} alt="Clan Group" className="h-7 w-7 object-contain opacity-80 group-hover:opacity-100" />
          </a>
        </div>
      </div>
    </footer>
  );
}
